import { OrderLabelKind } from '@modules/common/components/order-label';

// 訂單狀態
export const statusMap: {
  [key: string]: { style: OrderLabelKind; description: string };
} = {
  reviewing: {
    style: OrderLabelKind.Other,
    description: '訂單審核中',
  },
  pending: {
    style: OrderLabelKind.Processing,
    description: '訂單處理中',
  },
  completed: {
    style: OrderLabelKind.Done,
    description: '訂單完成',
  },
  canceled: {
    style: OrderLabelKind.Initial,
    description: '訂單取消',
  },
};

// 出貨狀態
export const fulfillmentStatusMap: {
  [key: string]: { style: OrderLabelKind; description: string };
} = {
  not_fulfilled: {
    style: OrderLabelKind.Initial,
    description: '待出貨',
  },
  partially_fulfilled: {
    style: OrderLabelKind.Processing,
    description: '備貨中',
  },
  fulfilled: {
    style: OrderLabelKind.Processing,
    description: '備貨中',
  },
  partially_shipped: {
    style: OrderLabelKind.Other,
    description: '部分出貨',
  },
  shipped: {
    style: OrderLabelKind.Processing,
    description: '已出貨',
  },
  delivered: {
    style: OrderLabelKind.Done,
    description: '已送達',
  },
  partially_delivered: {
    style: OrderLabelKind.Other,
    description: '部分送達',
  },
  canceled: {
    style: OrderLabelKind.Initial,
    description: '已取消',
  },
};
